import { createAction } from 'typesafe-actions';

import { ActionKeys } from './constants';

export const incrementPremiumAccessEducationWelcomeMessageCount = createAction(
  ActionKeys.INCREMENT_PREMIUM_ACCESS_EDUCATION_WELCOME_MESSAGE_COUNT,
)();
export type IncrementPremiumAccessEducationWelcomeMessageCountAction = ReturnType<
  typeof incrementPremiumAccessEducationWelcomeMessageCount
>;

export const incrementPremiumAccessEducationExitMessageCount = createAction(
  ActionKeys.INCREMENT_PREMIUM_ACCESS_EDUCATION_EXIT_MESSAGE_COUNT,
)();
export type IncrementPremiumAccessEducationExitMessageCountAction = ReturnType<
  typeof incrementPremiumAccessEducationExitMessageCount
>;

type UpdateWatchForMtupUnlockParams = $TSFixMe;
interface UpdateWatchForMtupUnlockPayload {
  flag: UpdateWatchForMtupUnlockParams;
}

export const updateWatchForMtupPlaylistUnlock = createAction(
  ActionKeys.UPDATE_WATCH_FOR_MTUP_UNLOCK,
  (flag: UpdateWatchForMtupUnlockParams) => ({ flag }),
)<UpdateWatchForMtupUnlockPayload>();
export type UpdateWatchForMtupUnlockAction = ReturnType<typeof updateWatchForMtupPlaylistUnlock>;

type UpdateMtupPlaylistReadyForMinicoachmarkParams = $TSFixMe;
interface UpdateMtupPlaylistReadyForMinicoachmarkPayload {
  flag: UpdateMtupPlaylistReadyForMinicoachmarkParams;
}

export const updateMtupPlaylistReadyForMinicoachmark = createAction(
  ActionKeys.UPDATE_MTUP_PLAYLIST_READY_FOR_MINICOACHMARK,
  (flag: UpdateMtupPlaylistReadyForMinicoachmarkParams) => ({ flag }),
)<UpdateMtupPlaylistReadyForMinicoachmarkPayload>();
export type UpdateMtupPlaylistReadyForMinicoachmarkAction = ReturnType<
  typeof updateMtupPlaylistReadyForMinicoachmark
>;

export default {
  incrementPremiumAccessEducationWelcomeMessageCount,
  incrementPremiumAccessEducationExitMessageCount,
};
